<div fxLayout="row" fxLayoutAlign="center" class="m-1">
  <div fxFlex="100" fxFlex.gt-sm="1 1 400px" fxFlex.sm="1 1 400px" class="mat-elevation-z6">
    <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
      <div class="p-4">
        <h1>{{ 'COMMON.CREATE-STANDBY' | translate }}</h1>

        <p class="mt-2"><b>{{ 'COMMON.PATIENT-NAME' | translate }}:</b>
          {{ form.get('patient').value?.Name || 'Not selected'}}</p>

        <mat-form-field class="w-100">
          <mat-select placeholder="{{ 'SCHEDULER.SELECT-PRACTICE' | translate }}" formControlName="practice">
            <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
            <mat-option *ngFor="let currentPractice of practices" [value]="currentPractice.ID">
              {{currentPractice.Name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-select placeholder="{{ 'SCHEDULER.SELECT-BRANCH' | translate }}" formControlName="branch">
            <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
            <mat-option *ngFor="let currentBranch of branches" [value]="currentBranch.BranchID">
              {{currentBranch.BusinessName}} {{ currentBranch.Address}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-select placeholder="{{ 'SCHEDULER.SELECT-THERAPIST' | translate }}" formControlName="scheduler">
            <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
            <mat-option *ngFor="let currentScheduler of schedulers" [value]="currentScheduler.Value">
              {{currentScheduler.Text}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-select placeholder="{{ 'SCHEDULER.SELECT-ROOM' | translate }}" formControlName="room">
            <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
            <mat-option *ngFor="let currentRoom of rooms" [value]="currentRoom.Value">
              {{currentRoom.Text}} </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- <mat-form-field class="w-100">
          <mat-select placeholder="{{ 'SCHEDULER.SELECT-VISIT-REASON' | translate }}" formControlName="reason">
            <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
            <mat-option *ngFor="let currentReason of visitReasons" [value]="currentReason.PriceListRefID">
              {{currentReason.Name}} {{currentReason.PriceListRefID}}</mat-option>
          </mat-select>
        </mat-form-field> -->

        <div class="w-100" fxLayout="column">
          <h4>{{ 'FIND-TIME.TREATMENTS-FOR-APPOINTMENT' | translate }}: </h4>
          <div *ngFor="let treatmentItem of treatments">
              <span>{{ getTreatmentSummary(treatmentItem) }}</span>
            </div>
    
            <div *ngFor="let pricelistCodeItem of priceListCodes">
              <span>{{ getPriceListSummary(pricelistCodeItem) }}</span>
            </div>
        </div>


        <div class="w-100 mt-3 mb-3" fxLayout="row wrap" fxLayoutGap="15px">
          <mat-checkbox *ngIf="firstDayOfWeek == 0" formControlName="sunday" color="primary">
            {{ 'DAYSOFWEEK.SUN' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="monday" color="primary">{{ 'DAYSOFWEEK.MON' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="tuesday" color="primary">{{ 'DAYSOFWEEK.TUE' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="wednesday" color="primary">{{ 'DAYSOFWEEK.WED' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="thursday" color="primary">{{ 'DAYSOFWEEK.THU' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="friday" color="primary">{{ 'DAYSOFWEEK.FRI' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="saturday" color="primary">{{ 'DAYSOFWEEK.SAT' | translate }}</mat-checkbox>
          <mat-checkbox *ngIf="firstDayOfWeek == 1" formControlName="sunday" color="primary">
            {{ 'DAYSOFWEEK.SUN' | translate }}</mat-checkbox>
        </div>


        <div fxLayout="row wrap">

          <mat-form-field class="ml-3" style="max-width: 130px;">
            <mat-label>{{ 'COMMON.FROM-DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="startDatepicker" formControlName="startDate">
            <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatepicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="ml-3" style="max-width: 130px;">
            <mat-label>{{ 'COMMON.TO-DATE' | translate }}</mat-label>
            <input matInput [matDatepicker]="endDatepicker" formControlName="endDate">
            <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatepicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div fxLayout="row wrap">

          <mat-form-field class="ml-3" style="max-width: 90px;">
            <mat-label>{{ 'COMMON.FROM-TIME' | translate }}</mat-label>
            <mat-select placeholder="{{ 'COMMON.FROM-TIME' | translate }}" formControlName="startTime">
              <mat-option *ngFor="let currentTime of fromTimeList" [value]="currentTime.Value">
                {{ currentTime.Text }} </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field class="ml-3" style="max-width: 90px;">
            <mat-label>{{ 'COMMON.TO-TIME' | translate }}</mat-label>
            <mat-select placeholder="{{ 'COMMON.TO-TIME' | translate }}" formControlName="endTime">
              <mat-option *ngFor="let currentTime of toTimeList" [value]="currentTime.Value">
                {{currentTime.Text}} </mat-option>
            </mat-select>
            <mat-error *ngIf="form.controls.endTime.hasError('startTimeGreaterThanEndTime')"> {{
              'ERROR.END-TIME-SMALLER-THEN-START-TIME' | translate}}</mat-error>
          </mat-form-field> -->

          <mat-form-field class="ml-3" style="width: 4em;">
            <mat-label>{{ 'COMMON.DURATION' | translate }}</mat-label>
            <input type="number" [attr.min]="minDuration" [attr.max]="maxDuration" step="5" matInput
              placeholder="{{ 'COMMON.DURATION' | translate }}" formControlName="duration">
            <mat-error *ngIf="form.controls.duration.errors?.required">{{ 'ERROR.DURATION-REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="form.controls.duration.hasError('min')">{{ 'ERROR.DURATION-MIN-INVALID' |translate: {
            'minutes': 5 } }}</mat-error>
            <mat-error *ngIf="form.controls.duration.hasError('max')">{{ 'ERROR.DURATION-MAX-INVALID' |translate: {
            'minutes': 120 } }}</mat-error>
          </mat-form-field>
        </div>


        <mat-form-field class="w-100">
          <mat-label>{{ 'COMMON.NOTE' | translate }}</mat-label>
          <textarea matInput placeholder="{{ 'COMMON.NOTE' | translate }}" formControlName="note" maxlength="256"
            cdkTextareaAutosize></textarea>
        </mat-form-field>

        <mat-form-field style="width: 4em;">
          <mat-label>{{ 'COMMON.PRIORITY' | translate }}</mat-label>
          <mat-select placeholder="{{ 'COMMON.PRIORITY' | translate }}" formControlName="priority">
            <mat-option *ngFor="let item of priorityList" [value]="item">
              {{item}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-error *ngIf="error" fxLayoutAlign="center" class="alert alert-danger">{{error}}</mat-error>
        <div fxLayoutAlign="center">
          <button mat-raised-button color="accent" class="mat-elevation-z6 ml-3" type="submit" [disabled]="!form.valid && !atLeastOneReqDropDownSelected">{{
          'COMMON.SAVE' | translate }}</button>
          <button mat-raised-button class="mat-elevation-z6 ml-3" type="button" (click)="onCancel()">{{
          'COMMON.CANCEL' | translate }}</button>
        </div>
      </div>

    </form>
  </div>
</div>